export default __webpack_public_path__ + "static/media/mob_light_iusd.7bb0f763.png";